import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OSCodePointsService from "../services/OSCodePointsService";

const useOSCodePointsService = () => {
    const { client } = useApiContext();
    const service = useMemo(() => {
        return new OSCodePointsService(client);
      }, [client]);
      return service;
}

export default useOSCodePointsService;